import { shallowEqual, useSelector } from 'react-redux'
import { CATALOG_IDS } from '@/constants'

export default function useCatalog() {
	const account = useSelector(state => state.auth?.account, shallowEqual)
	const selectedCatalog = useSelector(state => state.catalogs.selected, shallowEqual)

	const getUserCatalog = () => {
		return account?.catalog || null
	}

	const getSelectedCatalog = () => {
		return selectedCatalog || null
	}

	const isUsaCatalog = () => {
		const catalog = getUserCatalog()
		if (catalog === null) {
			return null
		}
		return catalog === CATALOG_IDS.usa
	}
	const isIntCatalog = () => {
		const catalog = getUserCatalog()
		if (catalog === null) {
			return null
		}
		return catalog === CATALOG_IDS.int
	}

	return {
		getSelectedCatalog,
		getUserCatalog,
		isUsaCatalog,
		isIntCatalog
	}
}
